import React, { type ReactElement } from 'react';

import classnames from 'classnames';

import styles from '../ColorGlowBackground.module.scss';

const GradientBackground = (): ReactElement => {
    return (
        <div aria-hidden className={classnames(styles.gradientBackground)}>
            <div className={classnames(styles.shape, styles.shape1)} />
            <div className={classnames(styles.shape, styles.shape2)} />
        </div>
    );
};

export default GradientBackground;
